<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-3 shape-red shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-12">
                                <h2 class="display-2 text-white">Updating Existing Hump System
                                    <span>We can rejuvenate your old system.</span>
                                </h2>
                                <p class="lead  text-white">We provide professional service to update your existing hump system in hardware and software. We can port your system to newer operating system or a different operating system. We also help to maintain your current systems.</p>
                                <!-- <div class="btn-wrapper">
                                    <base-button tag="a"
                                                 href="https://demos.creative-tim.com/argon-design-system/docs/components/alerts.html"
                                                 class="mb-3 mb-sm-0"
                                                 type="info"
                                                 icon="fa fa-code">
                                        Components
                                    </base-button>
                                    <base-button tag="a"
                                                 href="https://www.creative-tim.com/product/argon-design-system"
                                                 class="mb-3 mb-sm-0"
                                                 type="white"
                                                 icon="ni ni-cloud-download-95">
                                        Download HTML
                                    </base-button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>

        <section class="section section-lg bg-secondary section-skew">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-12">
                        <h2 class="display-2">Updating Existing Hump System </h2>
                        <!-- <p class="lead text-muted">Mainline Non-Vital Computer Aided Dispatching System</p> -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-lg-12 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/3z/roseville02.jpeg'"
                                 class="rounded img-center img-fluid shadow shadow-lg--hover">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Hump System</span>
                                    <!-- <small class="h6 text-muted">Hardware</small> -->
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
export default {
  name: "home",
  components: {}
};
</script>

<style lang="scss" scoped>
ul.list {
    padding-left: 1.2rem!important;
}
.section-skew {
    overflow: hidden;
    // padding-top: 20px;
    margin-top: 0px;
    position: relative;
    background: transparent;
    pointer-events: none;
    overflow: visible;
    &::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: -120px;
        height: 200px;
        background: #f4f5f7;
        -webkit-transform: skew(0, -8deg);
        transform: skew(0, -8deg);
    }
}
</style>
